import {
  faCalendar,
  faChartLineUp,
  faCheckCircle,
  faClock,
  faCopy,
  faCreditCard,
  faDownload,
  faFilePdf,
  faHandHoldingDollar,
  faUserHeadset
} from "@fortawesome/pro-regular-svg-icons";
import {
  faBell,
  faBuilding,
  faBuildingColumns,
  faCalendarClock,
  faClock as faClockSolid,
  faCommentQuestion,
  faEnvelope,
  faEnvelopeOpenDollar,
  faEuroSign,
  faEye,
  faFile,
  faFileContract,
  faFileInvoiceDollar,
  faFlagCheckered,
  faHandWave,
  faHouse,
  faLock,
  faMapMarkerAlt,
  faMoneyBillTransfer,
  faMoneyCheckDollar,
  faPhone,
  faRightLeft,
  faRotateLeft,
  faSackDollar,
  faSackXmark,
  faSearch,
  faSignOutAlt,
  faTimes,
  faUser,
  faUserTie,
  faXmark,
  faXmarkToSlot
} from "@fortawesome/pro-solid-svg-icons";

const icons = [
  faUser,
  faSearch,
  faEuroSign,
  faTimes,
  faUserHeadset,
  faChartLineUp,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faClock,
  faCheckCircle,
  faDownload,
  faFilePdf,
  faLock,
  faBell,
  faXmark,
  faCalendar,
  faCalendarClock,
  faSignOutAlt,
  faRightLeft,
  faHouse,
  faHandHoldingDollar,
  faXmarkToSlot,
  faSackXmark,
  faRotateLeft,
  faSackDollar,
  faEnvelopeOpenDollar,
  faEye,
  faCopy,
  faBuilding,
  faUserTie,
  faClockSolid,
  faHandWave,
  faFileInvoiceDollar,
  faMoneyCheckDollar,
  faBuildingColumns,
  faCommentQuestion,
  faFile,
  faCreditCard,
  faMoneyBillTransfer,
  faFileContract,
  faFlagCheckered
];

const aliases = {
  user: "fas fa-user",
  search: "fas fa-search",
  calender: "far fa-calendar",
  open: "fas fa-eye",
  copy: "far fa-copy",

  loans: "far fa-hand-holding-dollar",
  overview: "fas fa-house",
  contact: "far fa-user-headset",
  building: "fas fa-building",
  partner: "fas fa-user-tie",
  faq: "fas fa-comment-question",

  phone: "fas fa-phone",
  email: "fas fa-envelope",
  address: "fas fa-map-marker-alt",
  security: "fas fa-lock",
  notifications: "fas fa-bell",

  loanStatusRequested: "fas fa-envelope-open-dollar",
  loanStatusApproved: "fas fa-calendar-clock",
  loanStatusApprovedRenewal: "fas fa-calendar-clock",
  loanStatusApprovedAndPaid: "fas fa-sack-dollar",
  loanStatusRejected: "fas fa-xmark-to-slot",
  loanStatusCompletedAndRefunded: "fas fa-rotate-left",
  loanStatusDefaulting: "fas fa-triangle-exclamation",
  loanStatusIrrecoverable: "fas fa-triangle-exclamation",
  loanStatusDirectDebitProcessing: "fas fa-money-bill-transfer",

  directDebitStatusScheduled: "far fa-clock",
  directDebitStatusSuccessful: "fas fa-check",
  directDebitStatusFailed: "fas fa-xmark",
  directDebitStatusCancelled: "fas fa-times",
  directDebitStatusProcessing: "fas fa-money-bill-transfer",

  FinanceReceiverOnboardingStepWelcome: "fas fa-hand-wave",
  FinanceReceiverOnboardingStepQuoteAndFrameworkAgreement: "fas fa-file-invoice-dollar",
  FinanceReceiverOnboardingStepSepa: "fas fa-money-check-dollar",
  FinanceReceiverOnboardingStepPsd: "fas fa-building-columns",
  FinanceReceiverOnboardingStepTreatmentFee: "fas fa-euro-sign",

  lock: "fas fa-lock",
  card: "far fa-credit-card",

  waiting: "far fa-clock",
  openingHours: "fas fa-clock",
  done: "far fa-check-circle",

  download: "far fa-download",
  document: "fas fa-file",
  pdf: "far fa-file-pdf",
  psd: "fas fa-building-columns",

  messages: "fas fa-envelope",
  logout: "fas fa-sign-out-alt",

  ChangeCreditFacilityStepQuote: "fas fa-file-contract",
  ChangeCreditFacilityStepSepa: "fas fa-money-check-dollar",
  ChangeCreditFacilityStepPsd: "fas fa-building-columns",
  ChangeCreditFacilityStepComplete: "fas fa-flag-checkered"
};

export default {
  aliases,
  icons
};
